import React from 'react';
import classNames from 'classnames';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import Product from '../../../components/Product';

import './style.scss';

const Products = ({ entities }) => {
  return (
    <div className="Products">
      <Container>
        <div className="row">
          {entities.map((entity, index) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const classes = classNames('Products__row col-12 col-md-12 col-lg-6');

            return (
              <div key={`${uuid}:${langcode}`} className={classes}>
                <Product
                  isSmall
                  id={id}
                  key={`${uuid}:${langcode}`}
                  entity={entity}
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default Products;
